import React from 'react';
import { 
  Container, 
  Grid, 
  Card, 
  CardContent, 
  Typography, 
  CardActionArea,
  Box,
  IconButton,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import PageTitle from '../../components/PageTitle';

const StoresListPage = () => {
  const navigate = useNavigate();

  // Mock data for stores with stock images
  const stores = [
    {
      id: 1,
      name: 'Warpig Games',
      logo: 'https://images.unsplash.com/photo-1585504198199-20277593b94f?q=80&w=500&auto=format&fit=crop',
      location: 'Palermo, Buenos Aires',
    },
    {
      id: 2,
      name: 'El Hobbit',
      logo: 'https://images.unsplash.com/photo-1636489953081-c4ebbd50fa3a?q=80&w=500&auto=format&fit=crop',
      location: 'Recoleta, Buenos Aires',
    },
    {
      id: 3,
      name: 'Infinity Games',
      logo: 'https://images.unsplash.com/photo-1593814681464-eef5af2b0628?q=80&w=500&auto=format&fit=crop',
      location: 'Belgrano, Buenos Aires',
    },
    {
      id: 4,
      name: 'Gamer Studio',
      logo: 'https://images.unsplash.com/photo-1594122230689-45899d9e6f69?q=80&w=500&auto=format&fit=crop',
      location: 'San Telmo, Buenos Aires',
    },
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
        <IconButton 
          onClick={() => navigate('/torneos')}
          sx={{ 
            width: 40,
            height: 40,
            bgcolor: 'action.hover',
            color: 'text.primary',
            '&:hover': { 
              bgcolor: '#c89e38',
              color: 'white',
              transform: 'scale(1.1)'
            },
            transition: 'all 0.2s ease-in-out'
          }}
        >
          <ArrowBackIcon />
        </IconButton>
        <PageTitle title="Tiendas Participantes" />
      </Box>
      
      <Grid container spacing={3}>
        {stores.map((store) => (
          <Grid item xs={12} sm={6} md={4} key={store.id}>
            <Card 
              elevation={0}
              sx={{ 
                height: '100%',
                border: '1px solid',
                borderColor: 'divider',
                transition: 'transform 0.2s',
                '&:hover': {
                  transform: 'translateY(-4px)',
                }
              }}
            >
              <CardActionArea 
                onClick={() => navigate(`/torneos/tiendas/${store.id}`)}
                sx={{ height: '100%' }}
              >
                <CardContent>
                  <Box 
                    sx={{ 
                      display: 'flex', 
                      flexDirection: 'column',
                      alignItems: 'center',
                      gap: 2
                    }}
                  >
                    <Box 
                      component="img"
                      src={store.logo}
                      alt={store.name}
                      sx={{ 
                        width: '100%',
                        height: 200,
                        objectFit: 'cover',
                        borderRadius: 2,
                        mb: 1
                      }}
                    />
                    <Box sx={{ textAlign: 'center' }}>
                      <Typography variant="h6" component="div" gutterBottom>
                        {store.name}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {store.location}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default StoresListPage; 